import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';

import Counter from '../counter';
import LikeButton from '../like-button';
import styles from './like-button-with-count.scss';

const LikeButtonWithCount = ({ className, onClick, entity, showZero, switchCounterAndButton, isComment }) => {
  const { likeCount, isLikeInProgress, isLiked } = entity;

  return (
    <button className={classNames(styles.button, className)} onClick={onClick}>
      <span
        className={classNames(styles.flexContainer, switchCounterAndButton && styles.switchCounterAndButton)}
        data-hook="like-button-with-count__like-count"
      >
        <Counter
          className={classNames(styles.count, 'like-button-with-count__like-count')}
          count={likeCount}
          showZero={showZero}
          ariaHidden={true}
        />
        <LikeButton isLiked={isLiked} likeCount={likeCount} isDisabled={isLikeInProgress} isComment={isComment} />
      </span>
    </button>
  );
};

LikeButtonWithCount.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  entity: PropTypes.object.isRequired,
  showZero: PropTypes.bool,
  switchCounterAndButton: PropTypes.bool,
  isComment: PropTypes.bool,
};

LikeButtonWithCount.defaultProps = {
  showZero: false,
  switchCounterAndButton: false,
  isComment: false,
};

export default LikeButtonWithCount;
